import { compact } from "lodash";
import AppContext from "PFApp/app_context";
import { SubsidiaryModeAlert } from "PFApp/components/subsidiary_mode_alert/subsidiary_mode_alert";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import css from "./bulk_select_overlay.module.scss";

type BulkSelectOverlayProps = {
  activityType: "role" | "engagement";
};

export const BulkSelectOverlay = ({ activityType }: BulkSelectOverlayProps) => {
  const {
    store: {
      pages: {
        workflowPage: { roles, engagements }
      }
    }
  } = useContext(AppContext);

  const {
    selectedIds,
    setSelectedIds,
    modals: { share, addCoOwner }
  } = activityType === "role" ? roles : engagements;

  const { t } = useTranslation("workflow", { keyPrefix: "parts" });

  const onClose = () => {
    setSelectedIds([]);
  };

  const handleShare = () => {
    share.setVisibility(true);
  };

  const handleAddCoOwner = () => {
    addCoOwner.setVisibility(true);
  };

  return (
    <div className={css.container}>
      <div className={css.overlay} />
      <SubsidiaryModeAlert
        className={css.alert}
        title={t("rowsSelected", { count: selectedIds.length })}
        onClose={onClose}
        actions={compact([
          share && { icon: "share", onClick: handleShare },
          { icon: "add-profile", onClick: handleAddCoOwner }
        ])}
      />
    </div>
  );
};
